[
  {
    "kind": "UNION",
    "name": "ActivitiesEventExtension",
    "possibleTypes": [
      {
        "name": "ActivitiesCommentedEvent"
      },
      {
        "name": "ActivitiesTransitionedEvent"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "ActivitiesObjectExtension",
    "possibleTypes": [
      {
        "name": "ActivitiesJiraIssue"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "ActivityObjectData",
    "possibleTypes": [
      {
        "name": "ConfluenceBlogPost"
      },
      {
        "name": "ConfluenceDatabase"
      },
      {
        "name": "ConfluenceEmbed"
      },
      {
        "name": "ConfluenceFooterComment"
      },
      {
        "name": "ConfluenceInlineComment"
      },
      {
        "name": "ConfluencePage"
      },
      {
        "name": "ConfluenceWhiteboard"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "AllUpdatesFeedEvent",
    "possibleTypes": [
      {
        "name": "CommentUpdate"
      },
      {
        "name": "CreateUpdate"
      },
      {
        "name": "EditUpdate"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "CommentLocation",
    "possibleTypes": [
      {
        "name": "FooterComment"
      },
      {
        "name": "InlineComment"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "ConfluenceAncestor",
    "possibleTypes": [
      {
        "name": "ConfluenceDatabase"
      },
      {
        "name": "ConfluenceEmbed"
      },
      {
        "name": "ConfluenceFolder"
      },
      {
        "name": "ConfluencePage"
      },
      {
        "name": "ConfluenceWhiteboard"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "ConfluenceComment",
    "possibleTypes": [
      {
        "name": "ConfluenceFooterComment"
      },
      {
        "name": "ConfluenceInlineComment"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "ConfluenceCommentContainer",
    "possibleTypes": [
      {
        "name": "ConfluenceBlogPost"
      },
      {
        "name": "ConfluencePage"
      },
      {
        "name": "ConfluenceWhiteboard"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "ConfluenceInlineTaskContainer",
    "possibleTypes": [
      {
        "name": "ConfluenceBlogPost"
      },
      {
        "name": "ConfluencePage"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "ConfluenceLongTaskResult",
    "possibleTypes": [
      {
        "name": "ConfluenceCopyPageTaskResult"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "ConfluenceLongTaskState",
    "possibleTypes": [
      {
        "name": "ConfluenceLongTaskFailed"
      },
      {
        "name": "ConfluenceLongTaskInProgress"
      },
      {
        "name": "ConfluenceLongTaskSuccess"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "ConfluenceSearchResult",
    "possibleTypes": [
      {
        "name": "ConfluenceContentSearchResult"
      },
      {
        "name": "ConfluenceSpaceSearchResult"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "FeedEvent",
    "possibleTypes": [
      {
        "name": "FeedEventComment"
      },
      {
        "name": "FeedEventCreate"
      },
      {
        "name": "FeedEventEdit"
      },
      {
        "name": "FeedEventEditLive"
      },
      {
        "name": "FeedEventPublishLive"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "MediaAttachmentOrError",
    "possibleTypes": [
      {
        "name": "MediaAttachment"
      },
      {
        "name": "MediaAttachmentError"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "MutationErrorExtension",
    "possibleTypes": [
      {
        "name": "AdminAnnouncementBannerMutationErrorExtension"
      },
      {
        "name": "ConfluenceUpdateContentAccessRequestMutationErrorExtension"
      },
      {
        "name": "ConfluenceUpdateCustomContentPermissionsMutationErrorExtension"
      },
      {
        "name": "ConfluenceUpdatePdfExportConfigurationMutationErrorExtension"
      },
      {
        "name": "ConfluenceUpdateSiteConfigurationMutationErrorExtension"
      },
      {
        "name": "GenericMutationErrorExtension"
      },
      {
        "name": "PatchCommentsSummaryMutationErrorExtension"
      },
      {
        "name": "ReopenCommentsMutationErrorExtension"
      },
      {
        "name": "ResolveCommentsMutationErrorExtension"
      },
      {
        "name": "ResolveRestrictionsForSubjectMutationErrorExtension"
      },
      {
        "name": "UpdateExCoSpacePermissionsMutationErrorExtension"
      },
      {
        "name": "UpdateSpacePermissionsMutationErrorExtension"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "Node",
    "possibleTypes": [
      {
        "name": "ActivitiesEvent"
      },
      {
        "name": "ActivitiesItem"
      },
      {
        "name": "ActivitiesObject"
      },
      {
        "name": "ActivityNode"
      },
      {
        "name": "ConfluenceBlogPost"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "PageActivityEvent",
    "possibleTypes": [
      {
        "name": "PageActivityEventCreatedComment"
      },
      {
        "name": "PageActivityEventCreatedPage"
      },
      {
        "name": "PageActivityEventPublishedPage"
      },
      {
        "name": "PageActivityEventSnapshottedPage"
      },
      {
        "name": "PageActivityEventStartedPage"
      },
      {
        "name": "PageActivityEventUpdatedPage"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "Payload",
    "possibleTypes": [
      {
        "name": "ActivatePaywallContentPayload"
      },
      {
        "name": "AddPublicLinkPermissionsPayload"
      },
      {
        "name": "ArchiveSpacePayload"
      },
      {
        "name": "BulkDeleteContentDataClassificationLevelPayload"
      },
      {
        "name": "BulkRemoveRoleAssignmentFromSpacesPayload"
      },
      {
        "name": "BulkSetRoleAssignmentToSpacesPayload"
      },
      {
        "name": "BulkSetSpacePermissionAsyncPayload"
      },
      {
        "name": "BulkSetSpacePermissionPayload"
      },
      {
        "name": "BulkUpdateContentDataClassificationLevelPayload"
      },
      {
        "name": "ConfluenceAddCustomApplicationLinkPayload"
      },
      {
        "name": "ConfluenceChangeOrderOfCustomApplicationLinkPayload"
      },
      {
        "name": "ConfluenceCopySpaceSecurityConfigurationPayload"
      },
      {
        "name": "ConfluenceCreateAnswerPayload"
      },
      {
        "name": "ConfluenceCreateBlogPostPayload"
      },
      {
        "name": "ConfluenceCreateCustomRolePayload"
      },
      {
        "name": "ConfluenceCreateFooterCommentOnBlogPostPayload"
      },
      {
        "name": "ConfluenceCreateFooterCommentOnPagePayload"
      },
      {
        "name": "ConfluenceCreatePagePayload"
      },
      {
        "name": "ConfluenceCreatePdfExportTaskForBulkContentPayload"
      },
      {
        "name": "ConfluenceCreateCsvExportTaskPayload"
      },
      {
        "name": "ConfluenceCreatePdfExportTaskForSingleContentPayload"
      },
      {
        "name": "ConfluenceCreateQuestionPayload"
      },
      {
        "name": "ConfluenceCreateSpacePayload"
      },
      {
        "name": "ConfluenceDeleteAnswerPayload"
      },
      {
        "name": "ConfluenceDeleteCalendarCustomEventTypePayload"
      },
      {
        "name": "ConfluenceDeleteCustomApplicationLinkPayload"
      },
      {
        "name": "ConfluenceDeleteCustomRolePayload"
      },
      {
        "name": "ConfluenceDeleteGlobalPageTemplatePayload"
      },
      {
        "name": "ConfluenceDeleteQuestionPayload"
      },
      {
        "name": "ConfluenceDeleteSubCalendarAllFutureEventsPayload"
      },
      {
        "name": "ConfluenceDeleteSubCalendarEventPayload"
      },
      {
        "name": "ConfluenceDeleteSubCalendarHiddenEventsPayload"
      },
      {
        "name": "ConfluenceDeleteSubCalendarSingleEventPayload"
      },
      {
        "name": "ConfluenceDisableBlueprintPayload"
      },
      {
        "name": "ConfluenceDisableDefaultSpaceLogoPayload"
      },
      {
        "name": "ConfluenceDisableGlobalPageBlueprintPayload"
      },
      {
        "name": "ConfluenceDisableSpaceBlueprintPayload"
      },
      {
        "name": "ConfluenceEnableBlueprintPayload"
      },
      {
        "name": "ConfluenceEnableDefaultSpaceLogoPayload"
      },
      {
        "name": "ConfluenceEnableGlobalPageBlueprintPayload"
      },
      {
        "name": "ConfluenceImportSpacePayload"
      },
      {
        "name": "ConfluenceMarkAllCommentsAsReadPayload"
      },
      {
        "name": "ConfluencePromoteBlueprintPayload"
      },
      {
        "name": "ConfluencePromotePageTemplatePayload"
      },
      {
        "name": "ConfluencePublishBlogPostPayload"
      },
      {
        "name": "ConfluencePublishPagePayload"
      },
      {
        "name": "ConfluencePurgeBlogPostPayload"
      },
      {
        "name": "ConfluencePurgePagePayload"
      },
      {
        "name": "ConfluenceReopenCommentPayload"
      },
      {
        "name": "ConfluenceRepairJiraMacroAppLinksPayload"
      },
      {
        "name": "ConfluenceRequestSpaceAccessPayload"
      },
      {
        "name": "ConfluenceResetDefaultSpaceLogoPayload"
      },
      {
        "name": "ConfluenceResetJiraMacroAppLinksScanStatusPayload"
      },
      {
        "name": "ConfluenceResolveCommentByContentIdPayload"
      },
      {
        "name": "ConfluenceResolveCommentsPayload"
      },
      {
        "name": "ConfluenceSaveOrUpdateSpaceOwnerPayload"
      },
      {
        "name": "ConfluenceScanJiraMacroAppLinksPayload"
      },
      {
        "name": "ConfluenceTrashBlogPostPayload"
      },
      {
        "name": "ConfluenceTrashPagePayload"
      },
      {
        "name": "ConfluenceUnpromoteBlueprintPayload"
      },
      {
        "name": "ConfluenceUnpromotePageTemplatePayload"
      },
      {
        "name": "ConfluenceUpdateAnswerPayload"
      },
      {
        "name": "ConfluenceUpdateCurrentBlogPostPayload"
      },
      {
        "name": "ConfluenceUpdateCurrentPagePayload"
      },
      {
        "name": "ConfluenceUpdateCustomApplicationLinkPayload"
      },
      {
        "name": "ConfluenceUpdateCustomContentPermissionsPayload"
      },
      {
        "name": "ConfluenceUpdateCustomPageConfigurationPayload"
      },
      {
        "name": "ConfluenceUpdateCustomRolePayload"
      },
      {
        "name": "ConfluenceUpdateDraftBlogPostPayload"
      },
      {
        "name": "ConfluenceUpdateDraftPagePayload"
      },
      {
        "name": "ConfluenceUpdateEmailSiteConfigurationPayload"
      },
      {
        "name": "ConfluenceUpdateGlobalDefaultLocaleConfigurationPayload"
      },
      {
        "name": "ConfluenceUpdateGlobalPageTemplateDescriptionPayload"
      },
      {
        "name": "ConfluenceUpdateGlobalThemePayload"
      },
      {
        "name": "ConfluenceUpdateIndexingLanguageConfigurationPayload"
      },
      {
        "name": "ConfluenceUpdateManageAppsSettingsPayload"
      },
      {
        "name": "ConfluenceUpdateNewCodeMacroPayload"
      },
      {
        "name": "ConfluenceUpdatePdfExportConfigurationPayload"
      },
      {
        "name": "ConfluenceUpdateQuestionPayload"
      },
      {
        "name": "ConfluenceUpdateSiteConfigurationPayload"
      },
      {
        "name": "ConfluenceUpdateSiteSecurityConfigurationPayload"
      },
      {
        "name": "ConfluenceUpdateSiteSenderEmailAddressPayload"
      },
      {
        "name": "ConfluenceUpdateSlackSiteConfigurationPayload"
      },
      {
        "name": "ConfluenceUpdateSpacePayload"
      },
      {
        "name": "ConfluenceUpdateSpaceSettingsPayload"
      },
      {
        "name": "ConfluenceUpdateSpaceThemePayload"
      },
      {
        "name": "ConfluenceUpdateSubCalendarHiddenEventsPayload"
      },
      {
        "name": "ConfluenceUpdateTeamPresenceSiteConfigurationPayload"
      },
      {
        "name": "ConfluenceUploadDefaultSpaceLogoPayload"
      },
      {
        "name": "ConvertPageToLiveEditActionPayload"
      },
      {
        "name": "CreateContentMentionNotificationActionPayload"
      },
      {
        "name": "CreateFaviconFilesPayload"
      },
      {
        "name": "CreateInlineTaskNotificationPayload"
      },
      {
        "name": "CreateMentionNotificationPayload"
      },
      {
        "name": "CreateMentionReminderNotificationPayload"
      },
      {
        "name": "DeactivatePaywallContentPayload"
      },
      {
        "name": "DeleteContentDataClassificationLevelPayload"
      },
      {
        "name": "DeleteDefaultSpaceRoleAssignmentsPayload"
      },
      {
        "name": "DeleteExCoSpacePermissionsPayload"
      },
      {
        "name": "DeleteExternalCollaboratorDefaultSpacePayload"
      },
      {
        "name": "DeleteSpaceDefaultClassificationLevelPayload"
      },
      {
        "name": "DeleteSpaceRoleAssignmentsPayload"
      },
      {
        "name": "EditorDraftSyncPayload"
      },
      {
        "name": "FavouriteSpaceBulkPayload"
      },
      {
        "name": "NotificationResponsePayload"
      },
      {
        "name": "RecoverSpaceAdminPermissionPayload"
      },
      {
        "name": "RecoverSpaceWithAdminRoleAssignmentPayload"
      },
      {
        "name": "RemovePublicLinkPermissionsPayload"
      },
      {
        "name": "ResetSpaceRolesFromAnotherSpacePayload"
      },
      {
        "name": "ResetToDefaultSpaceRoleAssignmentsPayload"
      },
      {
        "name": "ResolveRestrictionsPayload"
      },
      {
        "name": "RestoreSpacePayload"
      },
      {
        "name": "SetDefaultSpaceRoleAssignmentsPayload"
      },
      {
        "name": "SetSpaceRoleAssignmentsPayload"
      },
      {
        "name": "SoftDeleteSpacePayload"
      },
      {
        "name": "UnarchiveSpacePayload"
      },
      {
        "name": "UpdateContentDataClassificationLevelPayload"
      },
      {
        "name": "UpdateCoverPictureWidthPayload"
      },
      {
        "name": "UpdateDefaultSpacePermissionsPayloadV2"
      },
      {
        "name": "UpdateExCoSpacePermissionsPayload"
      },
      {
        "name": "UpdateExternalCollaboratorDefaultSpacePayload"
      },
      {
        "name": "UpdateNestedPageOwnersPayload"
      },
      {
        "name": "UpdatePageOwnersPayload"
      },
      {
        "name": "UpdatePageStatusesPayload"
      },
      {
        "name": "UpdateSiteLookAndFeelPayload"
      },
      {
        "name": "UpdateSpaceDefaultClassificationLevelPayload"
      },
      {
        "name": "UpdateSpaceDetailsPayload"
      },
      {
        "name": "UpdateSpacePermissionsPayloadV2"
      },
      {
        "name": "UpdateSpaceTypeSettingsPayload"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "Person",
    "possibleTypes": [
      {
        "name": "Anonymous"
      },
      {
        "name": "KnownUser"
      },
      {
        "name": "UnknownUser"
      },
      {
        "name": "User"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "SmartFeaturesResultResponse",
    "possibleTypes": [
      {
        "name": "SmartFeaturesPageResultResponse"
      },
      {
        "name": "SmartFeaturesSpaceResultResponse"
      },
      {
        "name": "SmartFeaturesUserResultResponse"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "SmartLink",
    "possibleTypes": [
      {
        "name": "BlockSmartLink"
      },
      {
        "name": "EmbeddedSmartLink"
      },
      {
        "name": "InlineSmartLink"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "SpaceRolePrincipal",
    "possibleTypes": [
      {
        "name": "SpaceRoleAccessClassPrincipal"
      },
      {
        "name": "SpaceRoleGroupPrincipal"
      },
      {
        "name": "SpaceRoleGuestPrincipal"
      },
      {
        "name": "SpaceRoleUserPrincipal"
      },
      {
        "name": "SpaceRoleAppPrincipal"
      }
    ]
  }
]
